<template>
  <label :class="{ disabled }">
    <input
      v-bind="attrs"
      :checked="isChecked"
      type="checkbox"
      :aria-describedby="error ? `${attrs.name}-error` : null"
      :disabled="disabled"
      class="checkbox-input"
      tabindex="-1"
      @change="toggleChecked"
    />
    <i
      v-focus
      tabindex="0"
      :class="[
        'checkbox-icon',
        isChecked ? 'fa-solid fa-square-check' : 'fa-regular fa-square',
        { error },
      ]"
      @click="toggleChecked"
      @keydown.enter.prevent="toggleChecked"
    />
    <slot />
  </label>
  <span
    v-if="error"
    :id="`${attrs.name}-error`"
    class="error-text"
    role="alert"
  >
    <i class="fa-solid fa-ban"></i> {{ error }}
  </span>
</template>

<script setup>
import { useAttrs } from "vue";

const isChecked = defineModel("checked", { type: Boolean });
const props = defineProps({
  error: { type: String, default: null },
  disabled: { type: Boolean, default: false },
});

const attrs = useAttrs();

const toggleChecked = () => {
  if (!props.disabled) {
    isChecked.value = !isChecked.value;
  }
};
</script>

<style lang="scss" scoped>
.checkbox-input {
  position: absolute;
  left: 1px;
  height: 20px;
  width: 20px;
  opacity: 0;
  cursor: pointer;

  &:hover + .checkbox-icon {
    background-color: var(--clr-p2);
  }
}

.checkbox-icon {
  padding: 3px 3px 3px 4px;
  border-radius: 4px;
  color: var(--clr-p7);

  &.error {
    color: var(--clr-e200);
  }
}

label {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  width: fit-content;
  cursor: pointer;
}

.error-text {
  display: flex;
  gap: 4px;
  color: var(--clr-e300);
}

.disabled {
  cursor: not-allowed;

  .checkbox-input:focus + .checkbox-icon,
  .checkbox-input:hover + .checkbox-icon {
    background-color: unset;
  }
}
</style>
